import React from 'react'
import OverlayTrigger from 'react-bootstrap/esm/OverlayTrigger'
import styled from 'styled-components'
import { colors } from 'utils'
import { S as STooltip } from 'components/InfoTooltip'

const S = {
    Tag: styled.div<{ tagColor: string }>`
        display: flex;
        align-items: center;
        justify-content: center;
        width: 16px;
        height: 16px;
        margin: auto;
        border-radius: 3px;
        background-color: ${({ tagColor }) => tagColor};
        color: white;
        font-size: 14px;
        font-weight: bold;
    `,
    TagTooltip: styled.div<{ tagColor: string }>`
        position: relative;
        min-width: 100px;
        margin-bottom: 6px;
        padding-left: 18px;
        font-size: 14px;
        font-weight: 300;
        color: ${colors.dark};
        text-align: left;
        &:before {
            content: '';
            position: absolute;
            left: 0;
            top: 3px;
            width: 12px;
            height: 12px;
            border-radius: 3px;
            background-color: ${({ tagColor }) => tagColor};
        }
    `
}

const TagsIndicator = ({row}: {row: any}) => (
    row?.tags?.length ? (
        <OverlayTrigger
            key={row.id}
            placement="bottom-start"
            overlay={(
                <STooltip.Tooltip id={`tooltip-${row.id}`} theme="light" bsPrefix="tag">
                    {row.tags.map((tag) => (
                        <S.TagTooltip tagColor={tag.color} key={tag.id}>
                            {tag.text}
                        </S.TagTooltip>
                    ))}
                </STooltip.Tooltip>
            )}
        >
            <S.Tag tagColor={row.tags[0].color || 'transparent'} className="mr-2">
                {row?.tags?.length > 1 ? row?.tags?.length : ''}
            </S.Tag>
        </OverlayTrigger>
    ) : <div style={{ width: 16 }} className="mr-2" />
)

export default TagsIndicator
